import KopSurat from "./KopSurat";
import { useEffect, useState } from "react";
import Bismillah from "./Bismillah";
import { Downloads } from "../../helper/DownloadService";
import FotoSantri from "./FotoSantri";
import LogoBaladz from "./LogoBaladz";
import KeputusanPenerimaan from "./KeputusanPenerimaan";
import { FOTO_HOST } from "../../helper/Constant";


function PDFCommon({ dataSantri, templateKey }) {
    const [renderedContent, setRenderedContent] = useState([]);
    const [fotoSantri, setFotoSantri] = useState(null);

    useEffect(() => {
        // Load foto_santri if available
        if (dataSantri?.data_berkas?.[0]?.foto_santri) {
            let fotoSantriUrl = FOTO_HOST + dataSantri.data_berkas[0].foto_santri;
            Downloads.GetBase64Image(fotoSantriUrl).then((base64Image) => {
                setFotoSantri(base64Image);
            });
        }
    }, [dataSantri]);

    // ✅ Register available components with default props
    const availableComponents = {
        KopSurat: {
            component: KopSurat,
            defaultProps: {}
        },
        Bismillah: {
            component: Bismillah,
            defaultProps: {}
        },
        FotoSantri: {
            component: FotoSantri,
            defaultProps: {
                dataSantri: dataSantri,
                foto: fotoSantri
            }
        },
        LogoBaladz: {
            component: LogoBaladz,
            defaultProps: {}
        },
        KeputusanPenerimaan: {
            component: KeputusanPenerimaan,
            defaultProps: {
                dataSantri: dataSantri
            }
        },
        // Add more components here as needed
    };

    useEffect(() => {
        console.log('Template:', dataSantri?.tahun_ajaran?.[templateKey]);
        if (!dataSantri || !dataSantri.tahun_ajaran?.[templateKey]) {
            console.warn('Missing dataSantri or template');
            return;
        }

        try {
            const templateHtml = dataSantri.tahun_ajaran[templateKey];

            // ✅ Parse template with component support
            const parsedContent = parseTemplate(
                templateHtml,
                dataSantri,
                availableComponents
            );

            setRenderedContent(parsedContent);
        } catch (error) {
            console.error("Error rendering template:", error);
        }
    }, [dataSantri, templateKey]);

    const parseTemplate = (html, data = {}, components = {}) => {
        if (!html) return [];

        // Flatten nested data for easier access
        data.ayah = data.data_ayah?.[0];
        data.ibu = data.data_ibu?.[0];
        data.wali = data.data_wali?.[0];
        data.sekolah = data.data_sekolah?.[0];
        data.tujuan = data.data_tujuan?.[0];
        data.lain = data.data_lain?.[0];
        data.berkas = data.data_berkas?.[0];
        data.foto_santri = fotoSantri; // Add base64 foto

        console.log('Parsing template with data:', data);

        // ✅ Enhanced regex to capture component name and props
        // Supports: {{ComponentName prop1="value1" prop2="value2"}}
        let processedHtml = html.replace(/{{(?!\/)(.*?)}}/g, (match, content) => {
            const trimmedContent = content.trim();

            // Check if it starts with uppercase (component)
            if (/^[A-Z]/.test(trimmedContent)) {
                // Parse component name and props
                const parts = trimmedContent.match(/^(\w+)(?:\s+(.+))?$/);

                if (parts) {
                    const componentName = parts[1];
                    const propsString = parts[2] || '';

                    if (components[componentName]) {
                        // Create unique placeholder with props
                        const placeholder = `__COMPONENT_${componentName}_${Math.random().toString(36).substr(2, 9)}__`;

                        // Store props for later use
                        if (!window.__componentProps) {
                            window.__componentProps = {};
                        }
                        window.__componentProps[placeholder] = propsString;

                        return placeholder;
                    }
                }
            }

            // Handle nested data paths (e.g., ayah.nama)
            if (trimmedContent.includes('.')) {
                const keys = trimmedContent.split('.');
                let value = data;

                for (const key of keys) {
                    value = value?.[key];
                }

                return value ?? '';
            }

            // Simple data replacement
            return data[trimmedContent] ?? '';
        });

        // Split by component placeholders
        const parts = processedHtml.split(/(__COMPONENT_\w+_\w+__)/g);

        // Map parts to React elements
        return parts.map((part, index) => {
            // Check if it's a component placeholder
            const componentMatch = part.match(/__COMPONENT_(\w+)_(\w+)__/);

            if (componentMatch) {
                const componentName = componentMatch[1];
                const componentConfig = components[componentName];

                if (componentConfig) {
                    const Component = componentConfig.component || componentConfig;
                    const defaultProps = componentConfig.defaultProps || {};

                    // Parse props from placeholder
                    const propsString = window.__componentProps?.[part] || '';
                    const parsedProps = parseProps(propsString, data);

                    // Merge default props with parsed props
                    const finalProps = {
                        ...defaultProps,
                        ...parsedProps,
                        dataSantri: data, // Always pass full dataSantri
                        fotoSantri: fotoSantri,
                        key: `component-${index}`
                    };

                    console.log(`Rendering ${componentName} with props:`, finalProps);

                    return <Component {...finalProps} />;
                }
            }

            // Otherwise, render as HTML
            if (part.trim()) {
                return (
                    <div
                        key={`html-${index}`}
                        dangerouslySetInnerHTML={{ __html: part }}
                    />
                );
            }

            return null;
        }).filter(Boolean);
    };

    // ✅ Helper function to parse props string
    const parseProps = (propsString, data) => {
        const props = {};

        if (!propsString) return props;

        // Parse key="value" or key='value' or key={value}
        const propRegex = /(\w+)=(?:"([^"]*)"|'([^']*)'|{([^}]*)})/g;
        let match;

        while ((match = propRegex.exec(propsString)) !== null) {
            const key = match[1];
            const value = match[2] || match[3] || match[4];

            // Check if value references data (e.g., {nama_lengkap})
            if (match[4]) {
                // It's a data reference
                if (value.includes('.')) {
                    const keys = value.split('.');
                    let resolvedValue = data;
                    for (const k of keys) {
                        resolvedValue = resolvedValue?.[k];
                    }
                    props[key] = resolvedValue;
                } else {
                    props[key] = data[value];
                }
            } else {
                // It's a literal string
                props[key] = value;
            }
        }

        return props;
    };

    if (!dataSantri) {
        return <div>Loading...</div>;
    }

    if (!dataSantri.tahun_ajaran?.[templateKey]) {
        return (
            <div>
                <p>Template tidak tersedia</p>
            </div>
        );
    }

    return (
        <div>
            {renderedContent.length > 0 ? (
                renderedContent
            ) : (
                <div>Loading template...</div>
            )}
        </div>
    );
}

export default PDFCommon;